// in `src/router.js`

import { createRouter, createWebHistory } from "vue-router";
import LoginSite from "./views/LoginSite.vue";
import HomeSite from "./views/HomeSite.vue";
import RegisterSite from "./views/RegisterSite.vue";
import OKRCheckerStart from "./views/OKRCheckerStart.vue";

const routes = [
  {
    path: "/",
    component: HomeSite,
  },
  {
    path: "/login",
    component: LoginSite,
  },
  {
    path: "/register",
    component: RegisterSite,
  },
  {
    path: "/app-start",
    component: OKRCheckerStart,
  },
  // weitere Routen hier
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
